<script>
	import IntersectionObserver from "svelte-intersection-observer";
	import { height, debug, inviewIdx } from "./stores.js";
	import { getExpParams, isVideo } from "./utils.js";
	import Intervention from "./Intervention.svelte";
	import { getContext } from "svelte";
	import CardImage from "./CardImage.svelte";
	import CardVideo from "./CardVideo.svelte";

	export let entity_url;
	export let entity_id;
	export let idx;
	let element;
	let intersecting;
	let entities_engage;
	let intersect_events;
	let threshold;
	let currentInViewIdx;

	// reduce threshold in browser height is less than average card height
	if ($height < 400) {
		threshold = 0.3;
		if ($debug) {
			console.log(idx, "browser height <= average card height:", $height);
			console.log("threshold:", threshold);
		}
	} else {
		threshold = 1.0;
	}

	const expParams = getExpParams();
	// intervention modal
	const { open, close } = getContext("simple-modal");
	let idxPopup = expParams.intervention_idx;
	// show intervention
	$: if (
		currentInViewIdx >= idxPopup &&
		localStorage.getItem("modalShown") == "0"
	) {
		open(
			Intervention,
			{ onClose: close },
			{
				closeButton: false,
				closeOnOuterClick: false,
				closeOnEsc: false,
			},
			{},
		);
	}
</script>

<section class:inview={$debug && intersecting}>
	{#if $debug}
		{#if intersecting}
			<div style="color:white;text-align:center;background-color:red">
				{idx} IN VIEW (threshold: {threshold})
			</div>
		{:else}
			<div style="color:white;text-align:center;background-color:white">
				{idx} not in view (threshold: {threshold})
			</div>
		{/if}
	{/if}
	<IntersectionObserver
		{threshold}
		{element}
		bind:intersecting
		on:observe={(e) => {
			let intersectTime = +new Date();
			intersect_events = JSON.parse(
				localStorage.getItem("intersect_events"),
			);

			if (e.detail.isIntersecting) {
				// in view
				// save inview intersection time to compute RT for engagements
				entities_engage = JSON.parse(
					localStorage.getItem("entities_engage"),
				);
				entities_engage[entity_id]["lastViewTime"] = intersectTime;
				localStorage.setItem(
					"entities_engage",
					JSON.stringify(entities_engage),
				);
			}

			// save all events
			let intersectEvent = {
				idx: idx,
				inview: e.detail.isIntersecting,
				entity_id: entity_id,
				entity_url: entity_url,
				time: intersectTime,
			};
			intersect_events.push(intersectEvent);
			localStorage.setItem(
				"intersect_events",
				JSON.stringify(intersect_events),
			);

			// if not in view
			// determine dwell time for an entity_id: look or false-true-false pattern
			if (!e.detail.isIntersecting) {
				let dwelltime = 0;
				let addDwell = false;
				let inviewtime = 0;
				let lastThree = intersect_events
					.filter((i) => i.entity_id == entity_id)
					.slice(-3);
				let inviewBools = lastThree.map((i) => i.inview);
				if (lastThree.length === 3) {
					// must be false-true-false
					if (!inviewBools[0] && inviewBools[1] && !inviewBools[2]) {
						let times = lastThree.map((i) => i.time);
						inviewtime = times[1];
						dwelltime = times[2] - times[1];
						addDwell = true;
					}
				} else if (idx <= 4 && lastThree.length === 2) {
					// catch the first few entities that might always be in view initially
					// must be true-false
					if (inviewBools[0] && !inviewBools[1]) {
						let times = lastThree.map((i) => i.time);
						inviewtime = times[0];
						dwelltime = times[1] - times[0];
						addDwell = true;
					}
				}

				// if the last few intersecting events happen too quickly, don't register dwell
				const minDwellTime = 0; // ms
				const nEvents = 6; // last nEvents to consider (6 is based on testing)
				if (idx <= 1000000) {
					let lastFewEvents = intersect_events
						.map((i) => i.time)
						.slice(-nEvents);
					if (lastFewEvents.length > 2) {
						const elapsedTime =
							lastFewEvents[lastFewEvents.length - 1] -
							lastFewEvents[0];
						if (elapsedTime < 100) {
							// 100 is based on testing
							addDwell = false;
						}
					}
				}

				// update localStorage
				// save/register only certain dwelltimes
				if (dwelltime >= minDwellTime && addDwell) {
					console.log(idx, "dwelltime", dwelltime, "ms", entity_id);
					entities_engage = JSON.parse(
						localStorage.getItem("entities_engage"),
					);
					entities_engage[entity_id]["dwells"]++;
					entities_engage[entity_id]["dwellTimes"].push(dwelltime);
					entities_engage[entity_id]["dwellsInviewTime"].push(
						inviewtime,
					);
					localStorage.setItem(
						"entities_engage",
						JSON.stringify(entities_engage),
					);
					currentInViewIdx = idx;
					inviewIdx.set(idx);
				}
			}
		}}
	>
		<div bind:this={element}>
			{#if isVideo(entity_url)}
				<CardVideo {entity_id} {entity_url} {intersecting} {idx} />
			{:else}
				<CardImage {entity_id} {entity_url} />
			{/if}
			<!-- {#if idx < 5}
				<CardVideo {entity_id} {entity_url} {idx} />
			{:else}
				<CardImage {entity_id} {entity_url} />
			{/if} -->
			<!-- TODO: maybe add this: -/quality/lightest/-/format/jpeg/-/progressive/yes/ -->
			<!-- see  https://uploadcare.com/docs/transformations/image/compression/-->
		</div>
	</IntersectionObserver>

	{#if $debug}
		{#if intersecting}
			<div style="color:white;text-align:center;background-color:red">
				{idx} IN VIEW (threshold: {threshold})
			</div>
		{:else}
			<div style="color:white;text-align:center;background-color:white">
				{idx} not in view (threshold: {threshold})
			</div>
		{/if}
	{/if}
</section>

<style>
	.inview {
		border: 3px solid red;
		border-left: 13px solid red;
		border-right: 13px solid red;
		border-radius: 3px;
	}
</style>
